import { useParams } from 'react-router-dom';
import JobsView from './JobsView';
import React from 'react';

const JobsViewWrapper = () => {
  const { userId } = useParams<{ userId: string }>();
  return <JobsView userId={userId ? parseInt(userId) : null} />;
};

export default JobsViewWrapper;